import { useState } from 'react';
import { useStore } from 'react-redux';
import { setErrors } from 'redux/slices/systemSlice';
import useAryGetState from './useAryGetState';
import useAryRestData from './useAryRestData';

const useAryDelayedRestData = ({
  api,
  type,
  onSucceed,
  onFailed,
  method,
  onPending,
  intervalTime,
  requestTimeOut
}) => {
  const reduxStore = useStore();

  const [stateId, setStateId] = useState('');
  const [loading, setLoading] = useState(false);
  const [responseData, setResponseData] = useState('');

  const [postData] = useAryRestData(api, method);
  useAryGetState({
    stateId,
    type,
    onSucceed: () => {
      setLoading(false);
      if (onSucceed) {
        onSucceed(responseData);
      }
    },
    onFailed: () => {
      setLoading(false);
      if (onFailed) {
        onFailed();
      }
    },
    onPending,
    intervalTime,
    requestTimeOut
  });

  const delayedPostData = async (data) => {
    setLoading(true);
    const resp = await postData({ bodyData: data });
    if (resp.status === 200) {
      if (!resp.data.isDone) {
        setResponseData(resp.data);
        setStateId(resp.data.stateId);
      } else {
        setLoading(false);
        if (onSucceed) {
          onSucceed(resp.data);
        }
      }
    } else {
      setLoading(false);
      reduxStore.dispatch(
        setErrors({
          templateId: resp.data.templateId,
          metadata: resp.data.metadata
        })
      );
      if (onFailed) {
        onFailed();
      }
    }
  };

  return [delayedPostData, { loading }];
};

export default useAryDelayedRestData;
